"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
      backgroundColor: theme.palette.primary.main
    },
    typography: {
      padding: theme.spacing.unit * 3
    }
  };
};

var Tabs = function Tabs(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["classes", "children"]);

  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_core.Tabs, Object.assign({
    classes: {
      indicator: classes.tabsIndicator
    }
  }, props), children));
};

Tabs.defaultProps = {
  children: null
};

var _default = (0, _styles.withStyles)(styles)(Tabs);

exports.default = _default;